import React from 'react';
import { Section } from './ui/Section';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <Section bg="dark-800" className="border-y border-dark-700" data-id="element-203">
      <div className="max-w-4xl mx-auto bg-dark-900 border border-lime-500/30 rounded-3xl p-5 md:p-16 text-center relative overflow-hidden" data-id="element-204">
        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-lime-600 via-lime-400 to-lime-600" data-id="element-205"></div>

        <div className="inline-flex items-center justify-center w-16 h-16 md:w-24 md:h-24 rounded-full bg-dark-800 border border-lime-500/20 mb-4 md:mb-8" data-id="element-206">
          <ShieldCheck className="w-8 h-8 md:w-12 md:h-12 text-lime-500" data-id="element-207" />
        </div>

        <h2 className="text-2xl md:text-5xl font-display font-bold text-white mb-4 md:mb-8" data-id="element-208">
          GARANTÍA FUNCIONAL & CROSS 360 <br data-id="element-209" />
          <span className="text-lime-400" data-id="element-210">— 7 DÍAS</span>
        </h2>

        <div className="space-y-4 md:space-y-6 text-base md:text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-211">
          <p data-id="element-212">
            Abrís los 6 tomos. Revisás los 6 bonos. Los usás en tu clase si
            querés.
          </p>
          <p className="font-bold text-white text-lg md:text-xl" data-id="element-213">
            Si en 7 días no es lo que esperabas: Te devolvemos el 100%.
          </p>
          <p data-id="element-214">Sin preguntas. Sin formularios. Sin drama.</p>
          <p className="pt-4 md:pt-6 border-t border-dark-700 text-sm md:text-base" data-id="element-215">
            La confianza que tenemos en FUNCIONAL & CROSS 360 nos permite hacer
            esa promesa sin dudar. Más de 300 profes de funcional y cross
            training de todo el país ya lo saben.
          </p>
          <div className="inline-block mt-3 md:mt-4 px-3 py-1.5 md:px-4 md:py-2 bg-dark-800 rounded-lg border border-dark-700 text-lime-400 font-bold tracking-widest uppercase text-xs md:text-sm" data-id="element-216">
            La tasa de devoluciones es menor al 1%
          </div>
        </div>
      </div>
    </Section>;
}